import React from 'react';

// White card wrapper for one chart. Charts live on screen only - print shows the tables.
const ChartPanel = ({ title, children, className = '' }) => (
  <div className={`bg-white rounded-2xl shadow p-5 ${className}`}>
    <h3 className="font-semibold text-gray-900 mb-3">{title}</h3>
    {children}
  </div>
);

export default ChartPanel;
